import type { AuthProviderProps } from "react-oidc-context";
import { WebStorageStateStore, type User } from "oidc-client-ts";
import { rememberReturnTo } from "./returnTo";

const authority = import.meta.env.VITE_IDENTITY_AUTHORITY;
const clientId = import.meta.env.VITE_OIDC_CLIENT_ID;
const scope = import.meta.env.VITE_OIDC_SCOPES;

if (!authority || !clientId || !scope) {
    throw new Error(
        "OIDC env vars missing. Set VITE_IDENTITY_AUTHORITY, VITE_OIDC_CLIENT_ID, and VITE_OIDC_SCOPES."
    );
}

const appOrigin = window.location.origin;

function onSigninCallback(user: User | undefined) {
    // The page the user asked for before sign-in (ProtectedRoute's state).
    rememberReturnTo(user?.state);
    window.history.replaceState({}, document.title, window.location.pathname);
}

export const oidcConfig: AuthProviderProps = {
    authority,
    client_id: clientId,
    redirect_uri: `${appOrigin}/auth/callback`,
    silent_redirect_uri: `${appOrigin}/auth/silent-renew`,
    post_logout_redirect_uri: `${appOrigin}/`,
    response_type: "code",
    scope,
    automaticSilentRenew: true,
    loadUserInfo: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    onSigninCallback
};
